/**
 * @type {import('@chakra-ui/react').ThemeComponents}
 */
const Theme = {
  Text: {
    baseStyle: {
      color: 'text.base',
      fontFamily: 'Poppins',
      fontSize: 'md',
      lineHeight: 'normal',
    },
    sizes: {},
    variants: {
      small: {
        fontSize: 'xs',
        lineHeight: 'small',
      },
      pagination: {
        fontSize: 'md',
      },
      asideCardHeader: {
        size: 'xs',
        color: 'notification',
        fontWeight: 'bold',
      },
      warningBlock: {
        bgColor: 'complimentary.base',
        fontWeight: 'bold',
        p: '2',
      },
      iftiOutStanding: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '50px',
        fontWeight: '600',
        borderBottomLeftRadius: '8px',
        borderTopLeftRadius: '8px',
      },
      iftiHeading: {
        fontSize: '5xl',
        lineHeight: 'heading1',
        fontWeight: 'bold',
      },
    },
    defaultProps: {},
  },
};

export default Theme;
